import Phaser from 'phaser';
import {gsap} from 'gsap';


export default class Insentive{

    constructor(){
        this.scene =  GAME_REF.scene;
        this.$self = document.querySelector('.js-insentive');
        this.$iframe = document.querySelector('.js-insentive__video');
    }


    init(){
        this.$iframe.setAttribute('src', './movie/insentive.html');
    }


    render(){
        this.$iframe.contentWindow.player.playMovie();
        this.$self.classList.add('-active');
    }


    // 動画のiframeページから呼び出す
    playEnd(){
        gsap.to(this.$iframe, {opacity:0, duration:0.5, ease:'power2.out', onComplete:()=>{
            this.$iframe.setAttribute('src', '');
        }});
        
        this.scene.nextScene();
    }
}